const _allMensagens = [
	{
		val: 'AGENDAMENTOS DE EXAMES/PET CT E CINTILOGRAFIAS',
		text: 'Agendamentos de Exames/PET CT e Cintilografias',
		departamento: [1, 2, 3, 4, 5, 6, 7 , 8, 9],
		mensagens: [

			`*AGENDADO*
Exame: PET CT PSMA
Data: 14/03/23 (terça-feira).
Horário: 13:30h - Necessário chegar com 1h de antecedência

📍 São Carlos Saúde Oncológica - Rua Humaitá, 296 - Humaitá - RJ (Próximo ao Túnel Rebouças)

*O preparo do exame será encaminhado 24 h antes, através deste canal*

*Prazo de entrega do resultado: 5 dias úteis*`,

			`*PET CT - Oncológico*
Valor do exame: R$ 3.500,00
Forma de pagamento: Dinheiro, PIX , cartão de débito ou cartão de crédito em até 6 x sem juros`,
			
			`*PET CT - PSMA*
Valor do exame: R$ 3.400,00
Forma de pagamento: Dinheiro, PIX , cartão de débito ou cartão de crédito em até 6 x sem juros`,
			
			`*PET CT - DOTATATO*
Valor do exame: R$ 4.800,00
Forma de pagamento: Dinheiro, PIX , cartão de débito ou cartão de crédito em até 6 x sem juros`,
			
			`*PET CT - PSMA*
Valor do exame pelo Sistema Interclínicas: R$ 3.000,00
Forma de pagamento: Somente Dinheiro ou PIX
*Trazer guia rosa*`,
			
			`*PET CT - DOTATATO*
Valor do exame pelo Sistema Interclínicas: R$ 4.000,00
Forma de pagamento: Somente Dinheiro ou PIX
*Trazer guia rosa*`,
			
			`*PET CT - Oncológico*
Valor do exame pelo Sistema Interclínicas: R$ 2.700,00
Forma de pagamento: Somente Dinheiro ou PIX
*Trazer guia rosa*`,
			
			`Para o agendamento do PET, precisamos das seguintes informações:
- Idade
- Peso
- É diabético (a)?
- Realiza no momento tratamento de quimioterapia ou radioterapia? Caso sim, informar data da última e da próxima sessão
- E-mail para contato`,
			
			`Devido alteração no horário de entrega do medicamento utilizado no exame, foi necessário alterar o horário do seu agendamento`,

			`Confirmo o agendamento do seu exame de PET Dedicado Oncológico para o dia 21/07/2023 (sexta-feira) às 11:00h.

Chegar ao hospital com 60 minutos de antecedência (10:00h).

Informo que caso haja desistência do exame por parte do paciente, esta deve ser comunicada até dia 20/07/2023 às 10:30h, devido a solicitação prévia do material utilizado para o exame.

Segue preparo do exame, anexo.

-> No dia do exame trazer o pedido médico, identidade, carteira do convênio e exames anteriores com CD.

A São Carlos fica na Rua Humaitá, 296 - Humaitá - RJ -> Próximo ao Túnel Rebouças

Favor confirmar o recebimento desta mensagem.`,
			
			`*AGENDADO*
Exame: Cintilografia óssea
Data: 20/09/23 às 09:30h, quarta-feira.
📍 São Carlos Saúde Oncológica - Rua Humaitá, 296 – Humaitá - RJ

* Caso já tenha realizado este exame anteriormente, trazer os resultados e receitas de medicamentos de uso diário.*

*Segue abaixo, o preparo para realização do exame. Leia com atenção e em caso de dúvidas, entre em contato.*

Prazo de entrega do resultado: 5 dias úteis

📌*IMPORTANTE*
Na véspera do exame iremos entrar em contato através deste canal para a confirmação de sua presença. Caso essa mensagem não seja respondida até as 15h, o exame será automaticamente reagendado para a próxima data disponível.`,
			
			`O exame de Cintilografia de Tireóide é realizado em 2 dias seguidos:

1° dia - Administração da Dose do Iodo
2° dia - Captação/Imagem do exame

Este procedimento requer um preparo de 10 dias antes da realização, composto por uma dieta pobre em iodo.
Encaminho o preparo do exame e aguardo sua confirmação para finalizar o agendamento.`,
			
			`*AGENDADO*
*Exame*: Cintilografia de Tireóide

*Dieta*: De 28/05/23 até 07/06/23

*Dose*: 06/06/23 às 14h00, terça-feira

*Imagem*: 07/06/23 às 14h00, quarta-feira

📍 São Carlos Saúde Oncológica - Rua Humaitá, 296 – Humaitá - RJ`,
			
			`📌*IMPORTANTE*

O medicamento utilizado para realização deste exame é de alto custo e precisa ser cancelado em tempo hábil. Portanto, em caso de reagendamento ou cancelamento, pedimos a gentileza de nos comunicar até às 17h do dia anterior ao exame. Desta forma podemos cancelar a entrega do medicamento em tempo hábil.`,
			
			`Olá!
Falo da São Carlos Saúde Oncológica.
Gostaria de confirmar seu exame de Cintilografia que está agendado para amanhã, quinta-feira 30/09/23, às 08:30h.

Segue orientação/preparo para realização do exame.

📌*IMPORTANTE*
Caso não haja uma confirmação de presença até às 16:00, o exame é automaticamente reagendado.

O resultado será liberado em 5 dias úteis, e poderá acessá-lo através do nosso site ou clicando no link a seguir: https://resultados.saocarlossaudeoncologica.com.br/client/#/

📍 São Carlos Saúde Oncológica - Rua Humaitá, 296 – Humaitá - RJ`,
			
			`*CINTILOGRAFIA DO MIOCÁRDIO*

Exame é composto por 2 etapas:
Estresse/Esforço + Repouso

Recomendamos que realize as etapas em dias separados.

*Exemplo*:
Repouso - Quarta-feira
Estresse/Esforço - Quinta-feira

*OBS*: Caso queira realizar as duas etapas no mesmo dia, o tempo de permanência conosco é de 6 a 7 horas, devido a longa duração do exame.`,
			
			`📌*ATENÇÃO*
Para pacientes internados vindos de outros hospitais, é necessário trazer prescrição do dia e local, medicamentos e materiais.`,
			
			`*SISTEMA INTERCLÍNICAS - GUIA ROSA*
Tel.: 3473- 8621 / 2435-7849 / 2035-3218
Whatsapp: 99951-5928`,
		]
	},
	{
		val: 'AGENDAMENTO DE TRATAMENTOS/IODOTERAPIA',
		text: 'Agendamento de Tratamentos/Iodoterapia',
		departamento: [1, 2, 3, 4, 5, 6, 7 , 8, 9],
		mensagens: [

			`*AGENDADO*
Exame: PET CT PSMA
Data: 14/03/23 (terça-feira).
Horário: 13:30h - Necessário chegar com 1h de antecedência

📍 São Carlos Saúde Oncológica - Rua Humaitá, 296 - Humaitá - RJ (Próximo ao Túnel Rebouças)

*O preparo do exame será encaminhado 24 h antes, através deste canal*

*Prazo de entrega do resultado: 5 dias úteis*`,
			
			`*PET CT - Oncológico*
Valor do exame: R$ 3.500,00
Forma de pagamento: Dinheiro, PIX , cartão de débito ou cartão de crédito em até 6 x sem juros`,
			
			`*PET CT - PSMA*
Valor do exame: R$ 3.400,00
Forma de pagamento: Dinheiro, PIX , cartão de débito ou cartão de crédito em até 6 x sem juros`,
			
			`*PET CT - DOTATATO*
Valor do exame: R$ 4.800,00
Forma de pagamento: Dinheiro, PIX , cartão de débito ou cartão de crédito em até 6 x sem juros`,
			
			`*PET CT - PSMA*
Valor do exame pelo Sistema Interclínicas: R$ 3.000,00
Forma de pagamento: Somente Dinheiro ou PIX
*Trazer guia rosa*`,
			
			`*PET CT - DOTATATO*
Valor do exame pelo Sistema Interclínicas: R$ 4.000,00
Forma de pagamento: Somente Dinheiro ou PIX
*Trazer guia rosa*`,
			
			`*PET CT - Oncológico*
Valor do exame pelo Sistema Interclínicas: R$ 2.700,00
Forma de pagamento: Somente Dinheiro ou PIX
*Trazer guia rosa*`,
			
			`Para o agendamento do PET, precisamos das seguintes informações:
- Idade
- Peso
- É diabético (a)?
- Realiza no momento tratamento de quimioterapia ou radioterapia? Caso sim, informar data da última e da próxima sessão
- E-mail para contato`,
			
			`Devido alteração no horário de entrega do medicamento utilizado no exame, foi necessário alterar o horário do seu agendamento`,

			`Confirmo o agendamento do seu exame de PET Dedicado Oncológico para o dia 21/07/2023 (sexta-feira) às 11:00h.

Chegar ao hospital com 60 minutos de antecedência (10:00h).

Informo que caso haja desistência do exame por parte do paciente, esta deve ser comunicada até dia 20/07/2023 às 10:30h, devido a solicitação prévia do material utilizado para o exame.

Segue preparo do exame, anexo.

-> No dia do exame trazer o pedido médico, identidade, carteira do convênio e exames anteriores com CD.

A São Carlos fica na Rua Humaitá, 296 - Humaitá - RJ -> Próximo ao Túnel Rebouças

Favor confirmar o recebimento desta mensagem.`,
			
			`*AGENDADO*
Exame: Cintilografia óssea
Data: 20/09/23 às 09:30h, quarta-feira.
📍 São Carlos Saúde Oncológica - Rua Humaitá, 296 – Humaitá - RJ

* Caso já tenha realizado este exame anteriormente, trazer os resultados e receitas de medicamentos de uso diário.*

*Segue abaixo, o preparo para realização do exame. Leia com atenção e em caso de dúvidas, entre em contato.*

Prazo de entrega do resultado: 5 dias úteis

📌*IMPORTANTE*
Na véspera do exame iremos entrar em contato através deste canal para a confirmação de sua presença. Caso essa mensagem não seja respondida até as 15h, o exame será automaticamente reagendado para a próxima data disponível.`,
			
			`O exame de Cintilografia de Tireóide é realizado em 2 dias seguidos:

1° dia - Administração da Dose do Iodo
2° dia - Captação/Imagem do exame

Este procedimento requer um preparo de 10 dias antes da realização, composto por uma dieta pobre em iodo.
Encaminho o preparo do exame e aguardo sua confirmação para finalizar o agendamento.`,
			
			`*AGENDADO*
*Exame*: Cintilografia de Tireóide

*Dieta*: De 28/05/23 até 07/06/23

*Dose*: 06/06/23 às 14h00, terça-feira

*Imagem*: 07/06/23 às 14h00, quarta-feira

📍 São Carlos Saúde Oncológica - Rua Humaitá, 296 – Humaitá - RJ`,
			
			`📌*IMPORTANTE*

O medicamento utilizado para realização deste exame é de alto custo e precisa ser cancelado em tempo hábil. Portanto, em caso de reagendamento ou cancelamento, pedimos a gentileza de nos comunicar até às 17h do dia anterior ao exame. Desta forma podemos cancelar a entrega do medicamento em tempo hábil.`,
			
			`Olá!
Falo da São Carlos Saúde Oncológica.
Gostaria de confirmar seu exame de Cintilografia que está agendado para amanhã, quinta-feira 30/09/23, às 08:30h.

Segue orientação/preparo para realização do exame.

📌*IMPORTANTE*
Caso não haja uma confirmação de presença até às 16:00, o exame é automaticamente reagendado.

O resultado será liberado em 5 dias úteis, e poderá acessá-lo através do nosso site ou clicando no link a seguir: https://resultados.saocarlossaudeoncologica.com.br/client/#/

📍 São Carlos Saúde Oncológica - Rua Humaitá, 296 – Humaitá - RJ`,
			
			`*CINTILOGRAFIA DO MIOCÁRDIO*

Exame é composto por 2 etapas:
Estresse/Esforço + Repouso

Recomendamos que realize as etapas em dias separados.

*Exemplo*:
Repouso - Quarta-feira
Estresse/Esforço - Quinta-feira

*OBS*: Caso queira realizar as duas etapas no mesmo dia, o tempo de permanência conosco é de 6 a 7 horas, devido a longa duração do exame.`,
			
			`📌*ATENÇÃO*
Para pacientes internados vindos de outros hospitais, é necessário trazer prescrição do dia e local, medicamentos e materiais.`,
		]
	},
	{
		val: 'GERAL',
		text: 'Geral',
		departamento: [1, 2, 3, 4, 5, 6, 7 , 8, 9],
		mensagens: [

			`À disposição. Obrigada!`,

			`Olá! Como posso ajudar?`,

			`Algo mais em que eu possa ajudar?`,

			`Por gentileza, aguarde um momento enquanto verifico as informações solicitadas.`,

			`Por gentileza, aguarde um momento enquanto verifico a agenda disponível.`,
		]
	},

	{
		val: 'AGENDAMENTO DE EXAMES (TODOS: PET E CT CINTILOGRAFIA, TOMOGRAFIA, ECOCARDIOGRAMA',
		text: 'Agendamento de Exames (Todos: PET CT e Cintilografia, Tomografia, Ecocardiograma)',
		departamento: [1, 2, 3, 4, 5, 6, 7 , 8, 9],
		mensagens: [

			`*RESULTADOS DE EXAMES*

Link: https://resultados.saocarlossaudeoncologica.com.br/client/#/
Usuário:
Senha:
(Login e senha localizados na etiqueta do *protocolo de exames*, entregue no dia da realização do exame)

Caso não consiga clicando no link, deve seguir este caminho:
Entrar no site, clicar em “agendamento” e “resultados de exames” clicar em "Formulário de resultados" Clique no link abaixo para ter acesso aos resultados dos exames.

📌*IMPORTANTE*
Não esqueça de escolher a opção “PACIENTE" no perfil de usuário.

*Obs*: Realizamos entrega de resultados de exames de segunda a
sexta feira, de 14h às 17h.
*Necessário solicitar a impressão do exame pelo menos 24h antes da retirada.*`,
		]
	},

	{
		val: 'AGENDAMENTO DE TRATAMENTOS / IODOTERAPIA / RADIOTERAPIA E BETATERAPIA',
		text: 'Agendamento de Tratamentos / Iodoterapia / Radioterapia e Betaterapia',
		departamento: [1, 2, 3, 4, 5, 6, 7 , 8, 9],
		mensagens: [

			`*RESULTADOS DE EXAMES*

Link: https://resultados.saocarlossaudeoncologica.com.br/client/#/
Usuário:
Senha:
(Login e senha localizados na etiqueta do *protocolo de exames*, entregue no dia da realização do exame)

Caso não consiga clicando no link, deve seguir este caminho:
Entrar no site, clicar em “agendamento” e “resultados de exames” clicar em "Formulário de resultados" Clique no link abaixo para ter acesso aos resultados dos exames.

📌*IMPORTANTE*
Não esqueça de escolher a opção “PACIENTE" no perfil de usuário.

*Obs*: Realizamos entrega de resultados de exames de segunda a
sexta feira, de 14h às 17h.
*Necessário solicitar a impressão do exame pelo menos 24h antes da retirada.*`,
		]
	},

	{
		val: 'OUTROS ASSUNTOS',
		text: 'Outros Assuntos',
		departamento: [1, 2, 3, 4, 5, 6, 7 , 8, 9],
		mensagens: [

			`*RESULTADOS DE EXAMES*

Link: https://resultados.saocarlossaudeoncologica.com.br/client/#/
Usuário:
Senha:
(Login e senha localizados na etiqueta do *protocolo de exames*, entregue no dia da realização do exame)
damento do PET, precisamos das seguintes
informações:
Caso não consiga clicando no link, deve seguir este caminho:
Entrar no site, clicar em “agendamento” e “resultados de exames” clicar em "Formulário de resultados" Clique no link abaixo para ter acesso aos resultados dos exames.

📌*IMPORTANTE*
Não esqueça de escolher a opção “PACIENTE" no perfil de usuário.

*Obs*: Realizamos entrega de resultados de exames de segunda a
sexta feira, de 14h às 17h.
*Necessário solicitar a impressão do exame pelo menos 24h antes da retirada.*`,
		]
	},

	{
		val: 'AGENDAMENTO DE EXAMES / TOMOGRAFIA E ECOCARDIOGRAMA',
		text: 'Agendamento de Exames / Tomografia e Ecocardiograma',
		departamento: [1, 2, 3, 4, 5, 6, 7 , 8, 9],
		mensagens: [

			`*AGENDADO*
Exame: Tomografia Computadorizada
Data: 20/09/23 às 09:30h, quarta-feira.

📍 São Carlos Saúde Oncológica - Rua Humaitá, 296 – Humaitá - RJ

*Trazer laudos de exames anteriores*

Prazo de entrega do resultado: 5 dias úteis`,
		]
	},
	{
		val: 'AGENDAMENTO DE TRATAMENTOS / RADIOTERAPIA E BETATERAPIA',
		text: 'Agendamento de Tratamentos / Radioterapia e Betaterapia ',
		departamento: [1, 2, 3, 4, 5, 6, 7 , 8, 9],
		mensagens: [

			`Valor da consulta: R$ 650,00 - Forma de pagamento: Dinheiro ou Transferência bancária.`,

			`Infelizmente não temos cobertura do Bradesco para consulta de Betaterapia. Temos a opção de valor de tabela - R$ 350,00 , com emissão de nota fiscal para solicitação de reembolso.`,
			
			`Necessário passar por avaliação com nosso médico Radioterapeuta antes da cirurgia. Por se tratar de um procedimento pós cirúrgico, precisa ser conciliado.`,

			`Somente o médico Radioterapeuta pode definir o tipo de protocolo para encaminhar de acordo com sua necessidade.`,

			`Necessário trazer a carta do cirurgião no ato da consulta, junto com os documentos.`,
		]
	},

	{
		val: 'CIRURGIAS E BIÓPSIAS',
		text: 'Cirurgias e Biópsias',
		departamento: [1, 2, 3, 4, 5, 6, 7 , 8, 9],
		mensagens: [

			`Necessário agendamento de consulta de avaliação com Radiologista Intervencionista, mesmo já estando com o pedido da biópsia.
Valor da consulta: R$ 500,00. O valor do procedimento será informado pelo médico no dia da consulta.`,
			
			`Entramos em contato para confirmar sua Biópsia agendada para o dia 27/09/2023

Digite 1 para confirmar
Digite 2 para cancelar`,
			
			`Chegar ao hospital às 06:30 para internação.
Nossa anestesista, Dr.Priscila Pimentel, entrará em contato em breve para informar o preparo.`,
			
			`Orçamento para biópsia:

Parte cirúrgica: R$ 4.000,00 (Á vista/Pix)
Parte Hospitalar: R$ 3.500,00 (Parcelado no cartão até 3x sem juros)
Anestesista: R$ 1.200,00 (Á vista/Pix)

Paciente necessita entrar em contato com o laboratório de apoio para informações sobre valores do Histoquímico e Histopatológico.

*Laboratório Micro Imagem*
Telefone:(21) 2523-2262 / (21) 2522-6782.`,

			`Preparo para Biópsia Mama/Colocação Clip Mamário:

-Trazer exames recentes de mama
-Trazer pedido do procedimento
-Interromper uso de anticoagulante por 4 dias 
-Trazer TOP ou SUTIÃ justo
-Não vir dirigindo
`,
		]
	}

];

const getMensagens = () => _allMensagens;

module.exports = {
	getMensagens
}
